import _extends from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/extends";
import _classCallCheck from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _defineProperty from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import * as React from 'react';
import { TabRouter, StackActions, SceneView, createNavigator, NavigationActions } from '@react-navigation/core';
export default function createTabNavigator(TabView) {
  var NavigationView =
  /*#__PURE__*/
  function (_React$Component) {
    _inherits(NavigationView, _React$Component);

    function NavigationView() {
      var _getPrototypeOf2;

      var _this;

      _classCallCheck(this, NavigationView);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(NavigationView)).call.apply(_getPrototypeOf2, [this].concat(args)));

      _defineProperty(_assertThisInitialized(_this), "_renderScene", function (_ref) {
        var route = _ref.route;
        var _this$props = _this.props,
            screenProps = _this$props.screenProps,
            descriptors = _this$props.descriptors;
        var descriptor = descriptors[route.key];
        var TabComponent = descriptor.getComponent();
        return React.createElement(SceneView, {
          screenProps: screenProps,
          navigation: descriptor.navigation,
          component: TabComponent
        });
      });

      _defineProperty(_assertThisInitialized(_this), "_renderIcon", function (_ref2) {
        var route = _ref2.route,
            _ref2$focused = _ref2.focused,
            focused = _ref2$focused === void 0 ? true : _ref2$focused,
            tintColor = _ref2.tintColor,
            _ref2$horizontal = _ref2.horizontal,
            horizontal = _ref2$horizontal === void 0 ? false : _ref2$horizontal;
        var descriptors = _this.props.descriptors;
        var descriptor = descriptors[route.key];
        var options = descriptor.options;

        if (options.tabBarIcon) {
          return typeof options.tabBarIcon === 'function' ? options.tabBarIcon({
            focused: focused,
            tintColor: tintColor,
            horizontal: horizontal
          }) : options.tabBarIcon;
        }

        return null;
      });

      _defineProperty(_assertThisInitialized(_this), "_getButtonComponent", function (_ref3) {
        var route = _ref3.route;
        var descriptors = _this.props.descriptors;
        var descriptor = descriptors[route.key];
        var options = descriptor.options;

        if (options.tabBarButtonComponent) {
          return options.tabBarButtonComponent;
        }

        return null;
      });

      _defineProperty(_assertThisInitialized(_this), "_getLabelText", function (_ref4) {
        var route = _ref4.route;
        var descriptors = _this.props.descriptors;
        var descriptor = descriptors[route.key];
        var options = descriptor.options;

        if (options.tabBarLabel) {
          return options.tabBarLabel;
        }

        if (typeof options.title === 'string') {
          return options.title;
        }

        return route.routeName;
      });

      _defineProperty(_assertThisInitialized(_this), "_getAccessibilityLabel", function (_ref5) {
        var route = _ref5.route;
        var descriptors = _this.props.descriptors;
        var descriptor = descriptors[route.key];
        var options = descriptor.options;

        if (typeof options.tabBarAccessibilityLabel !== 'undefined') {
          return options.tabBarAccessibilityLabel;
        }

        var label = _this._getLabelText({
          route: route
        });

        if (typeof label === 'string') {
          var routes = _this.props.navigation.state.routes;
          return "".concat(label, ", tab, ").concat(routes.indexOf(route) + 1, " of ").concat(routes.length);
        }
      });

      _defineProperty(_assertThisInitialized(_this), "_getTestID", function (_ref6) {
        var route = _ref6.route;
        var descriptors = _this.props.descriptors;
        var descriptor = descriptors[route.key];
        var options = descriptor.options;
        return options.tabBarTestID;
      });

      _defineProperty(_assertThisInitialized(_this), "_makeDefaultHandler", function (_ref7) {
        var route = _ref7.route,
            navigation = _ref7.navigation;
        return function () {
          if (navigation.isFocused()) {
            if (route.hasOwnProperty('index') && route.index > 0) {
              // If current tab has a nested navigator, pop to top
              navigation.dispatch(StackActions.popToTop({
                key: route.key
              }));
            } else {
              navigation.emit('refocus');
            }
          } else {
            _this._jumpTo(route.routeName);
          }
        };
      });

      _defineProperty(_assertThisInitialized(_this), "_handleTabPress", function (_ref8) {
        var route = _ref8.route;
        _this._isTabPress = true;
        var descriptors = _this.props.descriptors;
        var descriptor = descriptors[route.key];
        var navigation = descriptor.navigation,
            options = descriptor.options;

        var defaultHandler = _this._makeDefaultHandler({
          route: route,
          navigation: navigation
        });

        if (options.tabBarOnPress) {
          options.tabBarOnPress({
            navigation: navigation,
            defaultHandler: defaultHandler
          });
        } else {
          defaultHandler();
        }
      });

      _defineProperty(_assertThisInitialized(_this), "_handleTabLongPress", function (_ref9) {
        var route = _ref9.route;
        var descriptors = _this.props.descriptors;
        var descriptor = descriptors[route.key];
        var navigation = descriptor.navigation,
            options = descriptor.options;

        var defaultHandler = _this._makeDefaultHandler({
          route: route,
          navigation: navigation
        });

        if (options.tabBarOnLongPress) {
          options.tabBarOnLongPress({
            navigation: navigation,
            defaultHandler: defaultHandler
          });
        } else {
          defaultHandler();
        }
      });

      _defineProperty(_assertThisInitialized(_this), "_handleIndexChange", function (index) {
        if (_this._isTabPress) {
          _this._isTabPress = false;
          return;
        }

        _this._jumpTo(_this.props.navigation.state.routes[index].routeName);
      });

      _defineProperty(_assertThisInitialized(_this), "_handleSwipeStart", function () {
        _this.setState({
          isSwiping: true
        });
      });

      _defineProperty(_assertThisInitialized(_this), "_handleSwipeEnd", function () {
        _this.setState({
          isSwiping: false
        });
      });

      _defineProperty(_assertThisInitialized(_this), "_jumpTo", function (routeName) {
        return _this.props.navigation.dispatch(NavigationActions.navigate({
          routeName: routeName
        }));
      });

      _defineProperty(_assertThisInitialized(_this), "_isTabPress", false);

      return _this;
    }

    _createClass(NavigationView, [{
      key: "render",
      value: function render() {
        var _this$props2 = this.props,
            descriptors = _this$props2.descriptors,
            navigation = _this$props2.navigation,
            screenProps = _this$props2.screenProps;
        var state = navigation.state;
        var route = state.routes[state.index];
        var descriptor = descriptors[route.key];

        var options = _objectSpread({}, this.props.navigationConfig, {}, descriptor.options);

        return React.createElement(TabView, _extends({}, options, {
          getLabelText: this._getLabelText,
          getButtonComponent: this._getButtonComponent,
          getAccessibilityLabel: this._getAccessibilityLabel,
          getTestID: this._getTestID,
          renderIcon: this._renderIcon,
          renderScene: this._renderScene,
          onIndexChange: this._handleIndexChange,
          onTabPress: this._handleTabPress,
          onTabLongPress: this._handleTabLongPress,
          navigation: navigation,
          descriptors: descriptors,
          screenProps: screenProps
        }));
      }
    }]);

    return NavigationView;
  }(React.Component);

  return function (routes) {
    var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var router = TabRouter(routes, config);
    return createNavigator(NavigationView, router, config);
  };
}